
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectEndpoint  } from 'webrtc-client-janus';


const endpointViewEnabled = () => !!window.endpointView;
const selectedWebHidDevice = () => window.endpointView?.selectedWebHidDevice
const getWebHidDeviceList = () => window.endpointView?.GetWebHidDeviceList()
const deselectWebHidDevice = () => window.endpointView?.deselectWebHidDevice()
const selectByWebHidDevice = (deviceId: string) => window.endpointView?.selectByWebHidDevice(deviceId)


const useWebHidControl = () => {
  const {status} = useSelector(selectEndpoint)
  // this should only work in electron
  const isElectron = navigator.userAgent.indexOf('electron') !== -1;
  const isWebHidEnabled = useMemo(() => status === 'online' && isElectron && endpointViewEnabled(), [isElectron, status])  

  return {
    isWebHidEnabled,
    getWebHidDeviceList,
    deselectWebHidDevice,
    selectByWebHidDevice,
    selectedWebHidDevice,
  }
}

export default useWebHidControl
